/* Keep gift packaging in a consistent order across product pages. */
(() => {
  if (!location.pathname.includes('/products/')) return;

  const query = new URL(location.href).searchParams;
  const explicitVariant = query.has('variant') || query.has('option_values');
  const rank = (name) => {
    const value = String(name || '').toLowerCase();
    if (value.includes('kraft paper')) return 0;
    if (value.includes('majestic maroon')) return 1;
    if (value.includes('nightingale garden') || value.includes('midnight teal')) return 2;
    if (value.includes('plum nightingale') || value.includes('jaipur rose')) return 3;
    if (value.includes('twilight garden')) return 4;
    if (value.includes('shahi darwaza')) return 100;
    return 50;
  };

  let defaultHandled = explicitVariant;
  let userChanged = false;
  document.addEventListener('change', (event) => {
    if (event.isTrusted && event.target.closest('variant-picker, variant-selects')) userChanged = true;
  }, true);

  function orderChoices(fieldset) {
    if (fieldset.dataset.p26GiftOrdered) return;
    const legend = fieldset.querySelector('legend');
    if (!/gift box/i.test(legend?.textContent || '')) return;
    const container = fieldset.querySelector('[data-option-selector]') || fieldset;
    const inputs = [...container.querySelectorAll(':scope > input[type="radio"]')];
    const pairs = inputs.map((input, index) => ({ input, label: input.nextElementSibling, index }))
      .filter(({ input, label }) => label?.tagName === 'LABEL' && label.htmlFor === input.id);
    if (pairs.length !== inputs.length || !pairs.length) return;
    fieldset.dataset.p26GiftOrdered = '1';
    pairs.sort((a, b) => rank(a.input.value) - rank(b.input.value) || a.index - b.index);
    pairs.forEach(({ input, label }) => container.append(input, label));
  }

  function setDefault(picker) {
    if (defaultHandled || userChanged || !picker) return;
    const fieldset = [...picker.querySelectorAll('fieldset')]
      .find((item) => /gift box/i.test(item.querySelector('legend')?.textContent || ''));
    if (!fieldset) return;
    const choices = [...fieldset.querySelectorAll('input[type="radio"]')];
    if (!choices.length) return;

    if (picker.tagName === 'VARIANT-PICKER') {
      if (!picker.product || !picker.masterSelector) return;
      const selected = picker.selectedVariant;
      const giftIndex = [...picker.querySelectorAll('fieldset')].indexOf(fieldset);
      if (!selected || giftIndex < 0) return;
      const variants = picker.product.variants;
      const target = choices.map((choice) => variants.find((variant) =>
        variant.available && variant.options[giftIndex] === choice.value &&
        variant.options.every((value, index) => index === giftIndex || value === selected.options[index])
      )).find(Boolean);
      if (!target) return;
      defaultHandled = true;
      if (target.id !== selected.id) picker.selectVariant(target.id);
    } else {
      const choice = choices.find((input) => !input.disabled && !input.classList.contains('disabled'));
      if (!choice) return;
      defaultHandled = true;
      if (!choice.checked) choice.click();
    }
  }

  function scan() {
    document.querySelectorAll('main variant-picker, main variant-selects').forEach((picker) => {
      picker.querySelectorAll('fieldset').forEach(orderChoices);
    });
    setDefault(document.querySelector('main variant-picker, main product-info variant-selects'));
  }

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan();
  // The India theme loads product data asynchronously after the picker appears.
  const retry = setInterval(() => {
    scan();
    if (defaultHandled || userChanged) clearInterval(retry);
  }, 150);
  setTimeout(() => clearInterval(retry), 8000);
})();
